import gql from 'graphql-tag'
import { graphql, OptionProps } from 'react-apollo'
import { ApolloQueryResult } from 'apollo-client'

const QUEUE_JOB_MUTATION = gql`
  mutation QueueJob($job: JobInput!, $caseId: ID) {
    queueJob(job: $job, caseId: $caseId) {
      jobId
      project {
        id
        cases {
          id
          lastResults
        }
      }
    }
  }
`

// TODO: Generate types from server
export type BeamInput = {
  name: string
  type: string
  profileType: 'D' | 'DR'
  pos: number
  span: number
  concreteGrade: string
  topConcrete: number
  fireResistance: string
}

export type SlabInput = {
  name: string
  type: string
  model: string
  pos: number
  side: 'left' | 'right'
  span: number
  topConcrete: number
  weight: number
}

export type LoadCaseLoadInput = {
  type: string
  name: string
  values: number[][]
  actsOn: string[]
}

export type LoadCaseInput = {
  name: string
  action: string
  stage: string
  loads: LoadCaseLoadInput[]
}

export type JobInput = {
  location: string
  spaceType: string
  elements: {
    beams: BeamInput[]
    slabs: SlabInput[]
    loadCases: LoadCaseInput[]
  }
}

type Response = {
  queueJob: {
    jobId: string
    project: {
      lastResults: string | null
    } | null
  }
}

export type WrappedProps = {
  queueJob: (
    jobSpec: JobInput,
    caseId: string | null
  ) => Promise<ApolloQueryResult<Response>>
} & OptionProps<{}, Promise<ApolloQueryResult<Response>>>

export function getWithQueueJobMutation<T>() {
  return graphql<Response, T, WrappedProps & T>(QUEUE_JOB_MUTATION, {
    props: ({ mutate }) => ({
      queueJob: (jobSpec: JobInput, caseId: string | null) =>
        mutate &&
        mutate({
          variables: {
            job: jobSpec,
            caseId
          }
        })
    })
  })
}



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/calculationQueries.ts